import React from "react"
import styled from "styled-components"
import Button from "./Button"
import { Link } from "gatsby"

import QR from "../images/qr.png"

const GridPitch = () => {
  return (
    <Container>
      <TextContainer>
        <h2>
          Get weekly roundups of the best training tools in your inbox, every Monday.
        </h2>
        <form
          action="https://app.audienceful.com/api/emails/subscribe/JGLXPSCNUCgXnRdcxNpD72"
          method="post"
        >
          <div class="f-row">
            <input
              name="email"
              type="email"
              id="email"
              placeholder="your@email.com"
              required
            />
          </div>
          <button type="submit">Subscribe</button>
          <div
            style={{ position: "absolute", left: -5000 }}
            aria-hidden="true"
          >
            <input type="text" name="b28-ft" tabindex="-1" value="" />
          </div>
        </form>

        <p>
          No spam – just thoughtful training advice
        </p>
      </TextContainer>
      {/* <div> */}
      {/*   <img */}
      {/*     width="200px" */}
      {/*     height="200px" */}
      {/*     alt="QR Code to download Programme" */}
      {/*     src={QR} */}
      {/*   /> */}
      {/* </div> */}
    </Container>
  )
}

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Container = styled.div`
  border-radius: 12px;
  background: var(--dark-grey);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
  min-height: 320px;

  img {
    border: 4px solid white;
    border-radius: 3px;
    box-shadow: 0px 2px 2px -1px rgba(0, 0, 0, 0.1);
    @media (max-width: 32em) {
      display: none;
    }
  }

  h2,
  p {
    margin: 0;
  }

  h2 {
    color: var(--white);
    font-weight: normal;
  }

  p {
    color: var(--light-grey);
  }

  form {
    display: flex;
    flex-direction: row;

    button {
      background: var(--blue);
      border-radius: 12px;
      padding: 8px 12px;
      color: white;
      border: none;
      outline: none;
      font-size: 18px;
      margin-left: 8px;
      cursor: pointer;
    }

  }

  input {
    border-radius: 12px;
    outline: none;
    background: rgba(0,0,0,0.3);
    border: 2px solid transparent;
    padding: 8px 12px;
    color: white;
    transition: 0.2s all;

    &:focus {
      border 2px solid white;
    }
  }

  @media (max-width: 500px) {
    input {
      width: 100%;
      margin-bottom: 12px;
    }
    form {
      flex-direction: column;
      button {
        margin-left: 0;
      }
    }
  }

  @media (max-width: 48em) {
    padding: 1.5em;
  }
`

const Buttons = styled.div`
  display: flex;
  margin-top: 20px;
`
export default GridPitch
